var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M11.683 7.43l-7.681 6.44v6.951c0 .375.298.679.666.679l4.67-.012a.672.672 0 00.662-.679v-4.06c0-.374.299-.678.667-.678h2.666c.369 0 .667.304.667.678v4.057a.671.671 0 00.665.68h.002l4.667.014a.672.672 0 00.666-.679v-6.956L12.32 7.43a.5.5 0 00-.637 0zm12.134 4.377l-3.483-2.923V3.009a.505.505 0 00-.5-.509H17.5c-.276 0-.5.228-.5.509v3.08l-3.73-3.125a1.974 1.974 0 00-2.542 0L.183 11.807a.514.514 0 00-.067.716l1.063 1.315c.175.218.49.249.703.07h.001l9.8-8.218a.5.5 0 01.638 0l9.8 8.218a.494.494 0 00.704-.068l1.063-1.315a.516.516 0 00-.07-.717l-.001-.001z"
  }))));
}

export default SvgHome;